var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Alert, AlertTitle, Box } from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useGetOne, useNotify, useRecordContext, useRefresh } from "react-admin";
import { EPublishType } from "./EPublishType";
import { PUBLISH_BALLOT } from "@/queries/PublishBallot";
import { PublishStatus, MAP_ELECTION_EVENT_STATUS_PUBLISH, nextStatus, } from "./EPublishStatus";
import { GENERATE_BALLOT_PUBLICATION } from "@/queries/GenerateBallotPublication";
import { GET_BALLOT_PUBLICATION_CHANGE } from "@/queries/GetBallotPublicationChanges";
import { GET_TASK_BY_ID } from "@/queries/GetTaskById";
import { PublishList } from "./PublishList";
import { PublishGenerate } from "./PublishGenerate";
import { UPDATE_EVENT_VOTING_STATUS } from "@/queries/UpdateEventVotingStatus";
import { UPDATE_ELECTION_VOTING_STATUS } from "@/queries/UpdateElectionVotingStatus";
import { IPermissions } from "@/types/keycloak";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { ETaskExecutionStatus, EVotingStatus, } from "@sequentech/ui-core";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { convertToNumber } from "@/lib/helpers";
import { EditPreview } from "./EditPreview";
import FormDialog from "@/components/FormDialog";
import { EPublishActions } from "@/types/publishActions";
import { getGraphQLActionErrorMessage } from "@/services/graphqlActionError";
var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["Edit"] = 0] = "Edit";
    ViewMode[ViewMode["View"] = 1] = "View";
    ViewMode[ViewMode["List"] = 2] = "List";
})(ViewMode || (ViewMode = {}));
var PublishMemo = React.memo(function (_a) {
    var _b, _c;
    var electionEventId = _a.electionEventId, electionId = _a.electionId, type = _a.type, showList = _a.showList;
    var MAX_DIFF_LINES = (_b = convertToNumber(process.env.MAX_DIFF_LINES)) !== null && _b !== void 0 ? _b : 500;
    var notify = useNotify();
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var _d = useState(ViewMode.List), viewMode = _d[0], setViewMode = _d[1];
    var _e = useState(false), changingStatus = _e[0], setChangingStatus = _e[1];
    var _f = useState(PublishStatus.Void), publishStatus = _f[0], setPublishStatus = _f[1];
    var _g = useState(PublishStatus.Void), publicationStatus = _g[0], setPublicationStatus = _g[1];
    var _h = React.useState(false), open = _h[0], setOpen = _h[1];
    var _j = useState(null), previewPublicationId = _j[0], setPreviewPublicationId = _j[1];
    var requestEpoch = useRef(0);
    var _k = useState(null), ballotPublicationId = _k[0], setBallotPublicationId = _k[1];
    var _l = useState(null), taskId = _l[0], setTaskId = _l[1];
    var _m = useState(null), publishError = _m[0], setPublishError = _m[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser;
    var canWrite = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_WRITE);
    var canRead = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_READ);
    var record = useRecordContext();
    // Used to show the election status
    var _o = useState(null), electionStatus = _o[0], setElectionStatus = _o[1];
    var _p = useState(null), electionPresentation = _p[0], setElectionPresentation = _p[1];
    var refresh = useRefresh();
    var _q = useState(null), generateData = _q[0], setGenerateData = _q[1];
    var publishBallot = useMutation(PUBLISH_BALLOT)[0];
    var getBallotPublicationChanges = useMutation(GET_BALLOT_PUBLICATION_CHANGE)[0];
    var generateBallotPublication = useMutation(GENERATE_BALLOT_PUBLICATION)[0];
    var _r = useMutation(UPDATE_EVENT_VOTING_STATUS), updateStatusEvent = _r[0], updateStatusEventError = _r[1].error;
    var updateStatusElection = useMutation(UPDATE_ELECTION_VOTING_STATUS)[0];
    var _s = useGetOne("sequent_backend_ballot_publication", {
        id: ballotPublicationId,
    }, {
        enabled: !!ballotPublicationId,
    }), ballotPublication = _s.data, refetch = _s.refetch;
    var generationTaskData = useQuery(GET_TASK_BY_ID, {
        variables: { task_id: taskId },
        skip: !taskId,
        pollInterval: taskId ? globalSettings.QUERY_POLL_INTERVAL_MS : 0,
    }).data;
    var onPublish = function () { return __awaiter(void 0, void 0, void 0, function () {
        var epoch, data, e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    epoch = requestEpoch.current;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 5, , 6]);
                    if (!!ballotPublicationId) return [3 /*break*/, 3];
                    return [4 /*yield*/, onGenerate()];
                case 2:
                    _d.sent();
                    return [2 /*return*/];
                case 3:
                    setPublishError(null);
                    setPublicationStatus(PublishStatus.PublishedLoading);
                    return [4 /*yield*/, publishBallot({
                            variables: {
                                electionEventId: electionEventId,
                                ballotPublicationId: ballotPublicationId,
                            },
                        })];
                case 4:
                    data = (_d.sent()).data;
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    if ((_a = data === null || data === void 0 ? void 0 : data.publish_ballot) === null || _a === void 0 ? void 0 : _a.ballot_publication_id) {
                        setBallotPublicationId((_b = data === null || data === void 0 ? void 0 : data.publish_ballot) === null || _b === void 0 ? void 0 : _b.ballot_publication_id);
                    }
                    refetch();
                    setViewMode(ViewMode.List);
                    notify(t("publish.notifications.published"), {
                        type: "success",
                    });
                    setPublishError(null);
                    setPublicationStatus(PublishStatus.Void);
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _d.sent();
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setPublishError((_c = getGraphQLActionErrorMessage(e_1)) !== null && _c !== void 0 ? _c : t("publish.dialog.error_publish"));
                    notify(t("publish.dialog.error_publish"), {
                        type: "error",
                    });
                    refresh();
                    setPublicationStatus(generateData ? PublishStatus.Generated : PublishStatus.Void);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var kioskModeEnabled = function () {
        var _a, _b, _c, _d;
        var status = (_b = (_a = record === null || record === void 0 ? void 0 : record.status) === null || _a === void 0 ? void 0 : _a.kiosk_voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.NOT_STARTED;
        var is_channel_enabled = (_d = (_c = record === null || record === void 0 ? void 0 : record.voting_channels) === null || _c === void 0 ? void 0 : _c.kiosk) !== null && _d !== void 0 ? _d : false;
        return {
            status: status,
            is_channel_enabled: is_channel_enabled,
        };
    };
    var onlineModeEnabled = function () {
        var _a, _b, _c, _d;
        var status = (_b = (_a = record === null || record === void 0 ? void 0 : record.status) === null || _a === void 0 ? void 0 : _a.voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.NOT_STARTED;
        var is_channel_enabled = (_d = (_c = record === null || record === void 0 ? void 0 : record.voting_channels) === null || _c === void 0 ? void 0 : _c.online) !== null && _d !== void 0 ? _d : false;
        return {
            status: status,
            is_channel_enabled: is_channel_enabled,
        };
    };
    var earlyVotingEnabled = function () {
        var _a, _b, _c, _d;
        var status = (_b = (_a = record === null || record === void 0 ? void 0 : record.status) === null || _a === void 0 ? void 0 : _a.early_voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.NOT_STARTED;
        var is_channel_enabled = (_d = (_c = record === null || record === void 0 ? void 0 : record.voting_channels) === null || _c === void 0 ? void 0 : _c.early_voting) !== null && _d !== void 0 ? _d : false;
        return {
            status: status,
            is_channel_enabled: is_channel_enabled,
        };
    };
    var telephoneVotingEnabled = function () {
        var _a, _b, _c, _d;
        var status = (_b = (_a = record === null || record === void 0 ? void 0 : record.status) === null || _a === void 0 ? void 0 : _a.telephone_voting_status) !== null && _b !== void 0 ? _b : EVotingStatus.NOT_STARTED;
        var is_channel_enabled = (_d = (_c = record === null || record === void 0 ? void 0 : record.voting_channels) === null || _c === void 0 ? void 0 : _c.telephone) !== null && _d !== void 0 ? _d : false;
        return {
            status: status,
            is_channel_enabled: is_channel_enabled,
        };
    };
    var onGenerate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var epoch, data, e_2;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    epoch = ++requestEpoch.current;
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    setBallotPublicationId(null);
                    setPublishError(null);
                    setGenerateData(null);
                    setTaskId(null);
                    setViewMode(ViewMode.Edit);
                    setPublicationStatus(PublishStatus.GeneratedLoading);
                    return [4 /*yield*/, generateBallotPublication({
                            variables: {
                                electionId: electionId,
                                electionEventId: electionEventId,
                            },
                        })];
                case 2:
                    data = (_g.sent()).data;
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setPublicationStatus(PublishStatus.GeneratedLoading);
                    if ((_a = data === null || data === void 0 ? void 0 : data.generate_ballot_publication) === null || _a === void 0 ? void 0 : _a.ballot_publication_id) {
                        setBallotPublicationId((_b = data === null || data === void 0 ? void 0 : data.generate_ballot_publication) === null || _b === void 0 ? void 0 : _b.ballot_publication_id);
                        setTaskId((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.generate_ballot_publication) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : null);
                    }
                    else {
                        throw "Publication Generation Error";
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _g.sent();
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setPublishError((_f = getGraphQLActionErrorMessage(e_2)) !== null && _f !== void 0 ? _f : t("publish.dialog.error"));
                    setBallotPublicationId(null);
                    notify(t("publish.dialog.error"), {
                        type: "error",
                    });
                    setPublicationStatus(PublishStatus.Void);
                    setViewMode(ViewMode.Edit);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeStatus = function (electionEventStatus, votingChannel) {
        var publishStatus = MAP_ELECTION_EVENT_STATUS_PUBLISH[electionEventStatus];
        var newStatus = nextStatus(publishStatus);
        handleSetPublishStatus(newStatus);
        if (type === EPublishType.Election) {
            onChangeElectionStatus(electionEventStatus, votingChannel);
        }
        else if (type === EPublishType.Event) {
            onChangeElectionEventStatus(electionEventStatus, votingChannel);
        }
    };
    var onChangeElectionStatus = function (votingStatus, votingChannel) { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setChangingStatus(true);
                    return [4 /*yield*/, updateStatusElection({
                            variables: {
                                votingStatus: votingStatus,
                                electionId: electionId,
                                electionEventId: electionEventId,
                                votingChannel: votingChannel,
                            },
                        })
                        // No matter the channel, we need to update the general publish status.
                        // That´s used to control the loading icon in the buttons for the transitions.
                    ];
                case 1:
                    _a.sent();
                    // No matter the channel, we need to update the general publish status.
                    // That´s used to control the loading icon in the buttons for the transitions.
                    handleSetPublishStatus(MAP_ELECTION_EVENT_STATUS_PUBLISH[votingStatus]);
                    setChangingStatus(false);
                    refresh();
                    notify(t("publish.notifications.change_status"), {
                        type: "success",
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    setChangingStatus(false);
                    notify(t("publish.dialog.error_status"), {
                        type: "error",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onChangeElectionEventStatus = function (electionEventStatus, votingChannel) { return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setChangingStatus(true);
                    return [4 /*yield*/, updateStatusEvent({
                            variables: {
                                electionEventId: electionEventId,
                                votingStatus: electionEventStatus,
                                votingChannel: votingChannel,
                            },
                        })];
                case 1:
                    _a.sent();
                    handleSetPublishStatus(MAP_ELECTION_EVENT_STATUS_PUBLISH[electionEventStatus]);
                    setChangingStatus(false);
                    refresh();
                    notify(t("publish.notifications.change_status"), {
                        type: "success",
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    setChangingStatus(false);
                    notify(t("publish.dialog.error_status"), {
                        type: "error",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchAllPublishChanges = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var epoch, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    epoch = requestEpoch.current;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getBallotPublicationChanges({
                            variables: {
                                electionEventId: electionEventId,
                                ballotPublicationId: ballotPublicationId,
                            },
                        })];
                case 2:
                    data = (_a.sent()).data.get_ballot_publication_changes;
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setGenerateData(data);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setViewMode(ViewMode.List);
                    setGenerateData(null);
                    setPublicationStatus(PublishStatus.Void);
                    notify(t("publish.dialog.error"), {
                        type: "error",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [ballotPublicationId, electionEventId, getBallotPublicationChanges]);
    var getPublishChanges = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var epoch, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    epoch = requestEpoch.current;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getBallotPublicationChanges({
                            variables: {
                                electionEventId: electionEventId,
                                ballotPublicationId: ballotPublicationId,
                                limit: MAX_DIFF_LINES / 10,
                            },
                        })];
                case 2:
                    data = (_a.sent()).data.get_ballot_publication_changes;
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setGenerateData(data);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    if (epoch !== requestEpoch.current)
                        return [2 /*return*/];
                    setViewMode(ViewMode.List);
                    setGenerateData(null);
                    setPublicationStatus(PublishStatus.Void);
                    notify(t("publish.dialog.error"), {
                        type: "error",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [ballotPublicationId, electionEventId, getBallotPublicationChanges]);
    var handleSetPublishStatus = useCallback(function (status) {
        if (publishStatus !== PublishStatus.Stopped) {
            setPublishStatus(status);
        }
    }, [publishStatus]);
    var onPreview = function (id) {
        setPreviewPublicationId(id);
        setOpen(true);
    };
    var handleCloseEditDrawer = function () {
        setOpen(false);
    };
    /**
     * Checks for any pending actions after the component mounts.
     * If a pending action is found, it executes the action and removes the flag.
     */
    useEffect(function () {
        var executePendingActions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isGold, pendingPublish;
            return __generator(this, function (_a) {
                isGold = isGoldUser();
                if (isGold) {
                    pendingPublish = sessionStorage.getItem(EPublishActions.PENDING_PUBLISH_ACTION);
                    if (pendingPublish) {
                        onGenerate();
                    }
                }
                return [2 /*return*/];
            });
        }); };
        var cleanup = function () {
            sessionStorage.removeItem(EPublishActions.PENDING_PUBLISH_ACTION);
        };
        if (electionEventId || electionId) {
            executePendingActions();
            cleanup();
        }
    }, [onChangeStatus, onGenerate]);
    useEffect(function () {
        if (showList) {
            requestEpoch.current++;
            setTaskId(null);
            setViewMode(ViewMode.List);
            setBallotPublicationId(null);
        }
    }, [showList]);
    useEffect(function () {
        if (electionEventId &&
            ballotPublicationId &&
            (ballotPublication === null || ballotPublication === void 0 ? void 0 : ballotPublication.id) === ballotPublicationId &&
            (ballotPublication === null || ballotPublication === void 0 ? void 0 : ballotPublication.is_generated)) {
            getPublishChanges();
        }
    }, [
        ballotPublicationId,
        ballotPublication === null || ballotPublication === void 0 ? void 0 : ballotPublication.is_generated,
        ballotPublication === null || ballotPublication === void 0 ? void 0 : ballotPublication.id,
        electionEventId,
        getPublishChanges,
    ]);
    // Tracks the async ballot style generation task (backed by
    // sequent_backend.tasks_execution) instead of polling
    // ballot_publication.is_generated forever - on SUCCESS it refetches
    // the publication once (which then flows into the effect above), on
    // FAILED it keeps the task's error visible on the publication details.
    var generationTask = (_c = generationTaskData === null || generationTaskData === void 0 ? void 0 : generationTaskData.sequent_backend_tasks_execution) === null || _c === void 0 ? void 0 : _c[0];
    useEffect(function () {
        var _a, _b, _c;
        if (!taskId || !generationTask || generationTask.id !== taskId) {
            return;
        }
        if (generationTask.execution_status === ETaskExecutionStatus.SUCCESS) {
            setTaskId(null);
            refetch();
        }
        else if (generationTask.execution_status === ETaskExecutionStatus.FAILED) {
            var logs = (_a = generationTask.logs) !== null && _a !== void 0 ? _a : [];
            var message = (_b = logs[logs.length - 1]) === null || _b === void 0 ? void 0 : _b.log_text;
            setTaskId(null);
            setPublishError((_c = getGraphQLActionErrorMessage({ message: message })) !== null && _c !== void 0 ? _c : t("publish.dialog.error"));
            setGenerateData(null);
            notify(t("publish.dialog.error_capacity", { message: message }), {
                type: "error",
            });
            setPublicationStatus(PublishStatus.Void);
            setViewMode(ViewMode.Edit);
        }
    }, [taskId, generationTask, notify, t, refetch]);
    useEffect(function () {
        if (ballotPublicationId) {
            refetch();
        }
    }, [refetch, ballotPublicationId]);
    useEffect(function () {
        if (generateData) {
            setPublicationStatus(PublishStatus.Generated);
            if (!viewMode) {
                notify(t("publish.notifications.generated"), {
                    type: "success",
                });
            }
        }
    }, [t, notify, viewMode, generateData]);
    useEffect(function () {
        var status = record === null || record === void 0 ? void 0 : record.status;
        handleSetPublishStatus((status === null || status === void 0 ? void 0 : status.voting_status)
            ? MAP_ELECTION_EVENT_STATUS_PUBLISH === null || MAP_ELECTION_EVENT_STATUS_PUBLISH === void 0 ? void 0 : MAP_ELECTION_EVENT_STATUS_PUBLISH[status === null || status === void 0 ? void 0 : status.voting_status]
            : PublishStatus.Void);
    }, [updateStatusEventError, handleSetPublishStatus, record]);
    useEffect(function () {
        var _a, _b;
        var status = (_a = record === null || record === void 0 ? void 0 : record.status) !== null && _a !== void 0 ? _a : null;
        var presentation = (_b = record === null || record === void 0 ? void 0 : record.presentation) !== null && _b !== void 0 ? _b : null;
        setElectionStatus(status);
        setElectionPresentation(presentation);
    }, [record]);
    return (_jsxs(Box, { sx: { flexGrow: 2, flexShrink: 0 }, children: [viewMode !== ViewMode.List && publishError ? (_jsxs(Alert, { severity: "error", onClose: function () { return setPublishError(null); }, sx: { mb: 2 }, children: [_jsx(AlertTitle, { children: t("publish.dialog.error_publish") }), _jsx(Box, { sx: { whiteSpace: "pre-line" }, children: publishError })] })) : null, viewMode === ViewMode.List && (_jsx(PublishList, { status: publishStatus, electionStatus: electionStatus, electionPresentation: electionPresentation, canRead: canRead, publishType: type, canWrite: canWrite, kioskModeEnabled: kioskModeEnabled(), onlineModeEnabled: onlineModeEnabled(), earlyVotingEnabled: earlyVotingEnabled(), telephoneVotingEnabled: telephoneVotingEnabled(), changingStatus: changingStatus, electionId: electionId, onGenerate: onGenerate, onChangeStatus: onChangeStatus, electionEventId: electionEventId, setBallotPublicationId: function (id) {
                    requestEpoch.current++;
                    setTaskId(null);
                    setViewMode(ViewMode.View);
                    setPublicationStatus(PublishStatus.GeneratedLoading);
                    setGenerateData(null);
                    setPublishError(null);
                    setBallotPublicationId(id);
                }, onPreview: onPreview })), (viewMode === ViewMode.Edit || viewMode === ViewMode.View) && (_jsx(PublishGenerate, { ballotPublicationId: ballotPublicationId, status: publicationStatus, changingStatus: changingStatus, readOnly: viewMode === ViewMode.View, data: generateData, publishType: type, onPublish: onPublish, electionId: electionId, onGenerate: onGenerate, onBack: function () {
                    requestEpoch.current++;
                    setTaskId(null);
                    setPublishError(null);
                    refetch();
                    setViewMode(ViewMode.List);
                    setPublicationStatus(PublishStatus.Generated);
                    setGenerateData(null);
                    setBallotPublicationId(null);
                }, electionEventId: electionEventId, fetchAllPublishChanges: fetchAllPublishChanges, onPreview: onPreview, kioskModeEnabled: kioskModeEnabled(), onlineModeEnabled: onlineModeEnabled(), earlyVotingEnabled: earlyVotingEnabled(), telephoneVotingEnabled: telephoneVotingEnabled() })), _jsx(FormDialog, { open: open, onClose: handleCloseEditDrawer, title: String(t("publish.dialog.title")), children: open && (_jsx(EditPreview, { publicationId: previewPublicationId, electionEventId: electionEventId, close: handleCloseEditDrawer }, "".concat(tenantId, "/").concat(electionEventId, "/").concat(previewPublicationId))) })] }));
});
PublishMemo.displayName = "Publish";
export var Publish = PublishMemo;
